import React, {useEffect, useMemo, useState} from 'react';
import {changeLanguage} from "../i18n";
import {isLocationIL} from "../functions";
import {useDispatch, useSelector} from "react-redux";
import {langOptions} from "@arboxappv4/shared/src/helpers/lang";
import {useTranslation} from "react-i18next";
import { useNavigate, useSearchParams } from 'react-router-dom';

const useLang = () => {
    const language = useSelector(state => state.site.language)
    const selectedLocation = useSelector(state => state.site.selectedLocation)
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const {i18n} = useTranslation()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
    const isTranslationReady = i18n.hasResourceBundle(i18n.language, 'translation');
    
    useEffect(() => {
        // this is only for first time initialization
        if(!language && selectedLocation) {
            setLoading(true)
            initLang()
        }
    }, [selectedLocation, language]);

    useEffect(() => {
        if(language) {
            fetchLang()
        }
    }, [language]);

    const initLang = async () => {
        const lang = params.lang
        if(lang === 'he' || (isLocationIL() && !lang)) {
            await changeLanguage(langOptions.he, dispatch, navigate)
        } else {
            await changeLanguage(langOptions.en, dispatch, navigate)
        }
        setLoading(false)
    }

    const fetchLang = async () => {
        const lang = params.lang
        if(lang && (lang !== language.code) && langOptions[lang]) {
            await changeLanguage(langOptions[lang], dispatch, navigate)
        } else {
            await changeLanguage(language, dispatch, navigate)
        }
        setLoading(false)
    }

    return {ready: !loading && isTranslationReady}
};

export default useLang;